import antDirective from '../_util/antDirective';
var base = {};
var install = function install(Vue) {
  base.Vue = Vue;
  Vue.use(antDirective);
};
base.install = install;

export default base;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/base/index.js
// module id = 10
// module chunks = 0